import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { ModalService, RewardItemService,LocationCoreService, OfferService, ProxyService } from '@app/core/services';
import * as Store from '@core/redux/stores';
import { Actions, ChildRecipeResponse, IAppState, LocationsEntity, LoyaltyMode, Order, PickupType } from '@core/redux/stores';
import { NgRedux, select } from '@angular-redux/store';
import { Router } from '@angular/router';
import _ from 'lodash';
import { GtmService } from './gtm.service';
import { PickupPath } from '../models/payment-service-models.model';
import { first } from 'rxjs/operators';
import { RewardService } from '@app/features/rewards/services/reward.service';
import { RewardPointMenuItem } from '../models/loyalty.model';
import { ApiRoutes } from '@app/shared/models/configs/api.endpoints';
import { MessageSummaryLoyalty } from '@app/features/account/messaging/models';
import { environment } from '@environments/environment';
import { UtilitiesService } from '@core/services';
import { Constants } from '@core/constants/core.constants';

@Injectable({
  providedIn: 'root'
})
export class SelectPickupService {
  @select((appState) => appState.activeOrder) activeOrder: Observable<Order>;
  @select((appState) => appState.locationSelected) locationSelected: Observable<LocationsEntity>;
  private pickupPathSetSubject = new BehaviorSubject<PickupPath>(null);
  public isPickupPathSet$ = this.pickupPathSetSubject.asObservable();
  private deliveryAddressSetSubject = new BehaviorSubject<boolean>(false);
  public isDeliveryAddressSet$ = this.deliveryAddressSetSubject.asObservable();
  orderId: any;
  pointRewardItem: RewardPointMenuItem;
  private order: Order;
  orderType: string;
  favoriteId: any;
  location: Store.LocationsEntity;
  guestOrderId: any;
  private screen: string;
  private PickupPathDisplayValue = [
    {
      'id': 1,
      'name': 'Delivery'
    },
    {
      'id': 2,
      'name': 'Pickup'
    }]
  showPickupModal(id: any, orderType: string, screen: string = null) {
    this.setPickupProperties(orderType, id);
    this.orderType = orderType;
    this.screen = screen;
    if (!this.order?.pickupPath 
       || screen === 'Header' || !this.order?.childRecipes?.length) {
      this.isDeliveryAddressSet(false);
      this.isPickupPathSet(null);
      this.ngRedux.dispatch({ type: Actions.CLEARLOATIONSELECTED });
      this.cleanUpDeliveryFlow();
      setTimeout(() => {
        this.locationCoreService.checkNearestLocationAvailability('selectPickupModal', function() {this.showModal('app-select-pickup');}.bind(this));
      }, 200);
    } else if (this.order.pickupPath) {
      this.routeStartNewOrder();
    } else if (orderType === 'order') {
      this.router.navigate(['/menu'], {
        queryParams: UtilitiesService.generateQueryParams([Constants.ORDER_ID],[id])
      });
    } else if (orderType === 'favorite') {
      this.router.navigate(['/menu'], {
        queryParams:
        UtilitiesService.generateQueryParams([Constants.FAVORITE_ID],[id])
      });
    } else if (orderType === 'guestOrder') {
      this.router.navigate(['/menu'], {
        queryParams: UtilitiesService.generateQueryParams([Constants.ORDER_ID, Constants.GUEST_ORDER],[id, true])
      });
    }
  }
  private cleanUpDeliveryFlow() {
    if (this.order?.pickupType === PickupType.Delivery || this.order?.deliveryQuote) {
      // Abandoned delivery flow - remove details
      this.order.pickupPath = null;
      this.order.pickupType = null;
      this.order.deliveryAddress = null;
      this.order.deliveryQuote = null;
      this.order.automaticDeliveryLocation = null;
      this.ngRedux.dispatch({ type: Actions.UPDATEORDER, data: this.order });
    }
  }

  public closePickupPathSubject() {
    if (this.pickupPathSetSubject && !this.pickupPathSetSubject?.closed) {
      this.pickupPathSetSubject.unsubscribe();
    }
  }
  public closeDeliveryAddressSubject() {
    if (this.deliveryAddressSetSubject && !this.deliveryAddressSetSubject.closed) {
      this.deliveryAddressSetSubject.unsubscribe();
    }
  }
  constructor(private modalService: ModalService,
    private ngRedux: NgRedux<IAppState>,
    private router: Router,
    private locationCoreService: LocationCoreService,
    private offerService: OfferService,
    private gtmService: GtmService,
    private rewards: RewardService,
    private rewardItemService: RewardItemService,
    private http: ProxyService) {
    this.activeOrder.subscribe(
      (data) => {
        this.order = _.cloneDeep(data);
        if(!data) {
          this.initializePickupService();
        }
      }
    );
      this.locationSelected.subscribe(
        (loc) => {
          this.location = loc;
        }
      )
  }
  private setPickupProperties(orderType: string, id: any) {
    if (orderType === 'order') {
      this.orderId = id;
      this.favoriteId = null;
      this.guestOrderId = null;
    } else if (orderType === 'favorite') {
      this.favoriteId = id;
      this.orderId = null;
      this.guestOrderId = null;
    } else if (orderType === 'guestOrder') {
      this.guestOrderId = id;
      this.orderId = null;
      this.favoriteId = null;
    } else if(orderType === 'reward' && id && id?.parentRecipeId && id.childRecipeIds?.length) {      
      this.pointRewardItem = _.cloneDeep(id);
      id = null;
    }
  }

  isDeliveryAddressSet(status: boolean) {
    if (this.deliveryAddressSetSubject.closed) {
      this.deliveryAddressSetSubject = new BehaviorSubject<boolean>(false);
    }
    this.deliveryAddressSetSubject.next(status);
  }
  showModal(name: string) {
    this.modalService.setModalSelector(name);
    this.modalService.showModal();
  }
  public isPickupPathSet(pickupPath: PickupPath) {
    if (this.pickupPathSetSubject.closed) {
      this.pickupPathSetSubject = new BehaviorSubject<PickupPath>(null);
    }
    this.pickupPathSetSubject.next(pickupPath);
    if (pickupPath) {
      const order_method: string = this.PickupPathDisplayValue.find(p => p.id === pickupPath)?.name;
      const orderMethodSelectEvent = {
        event: 'order_method_select',
        event_name: 'order_method_select',
        order_method: order_method,
        screen_name: this.screen ? this.screen.slice() : 'Home',
        click_text: 'Order for ' + order_method
      }
      this.gtmService.sendGenericEvent(orderMethodSelectEvent);
      if (this.order?.childRecipes?.length > 0) {
        this.continueWithOrder(pickupPath);
      } else {
        this.activeOrder.pipe(first()).toPromise().then(
          success => {
            this.order = _.cloneDeep(success);
            this.continueWithOrder(pickupPath);
          }, () => this.continueWithOrder(pickupPath));
      }
    }
  }
  private continueWithOrder(pickupPath: PickupPath) {
    this.screen = null;
    const orderdCollection = this.order ?? new Store.Order();
    orderdCollection.pickupPath = pickupPath;
    if (pickupPath === PickupPath.Delivery) {
      orderdCollection.pickupType = PickupType.Delivery;
      orderdCollection.automaticDeliveryLocation = true;
    } else {
      orderdCollection.automaticDeliveryLocation = false;
    }
    this.ngRedux.dispatch({ type: Actions.UPDATEORDER, data: orderdCollection });
    if (pickupPath === PickupPath.Delivery) {
      if(this.favoriteId) {
        this.router.navigate(['/order-review'], {
          queryParams: 
          UtilitiesService.generateQueryParams([Constants.FAVORITE_ID], [this.favoriteId])
        });
      } else if(this.orderId){
        this.router.navigate(['/order-review'], {
          queryParams: 
          UtilitiesService.generateQueryParams([Constants.ORDER_ID], [this.orderId])
        });
        this.orderId = null;
      } else if(this.guestOrderId) {
        this.router.navigate(['/order-review'], {
          queryParams: 
          UtilitiesService.generateQueryParams([Constants.GUEST_ORDER_ID], [this.guestOrderId])
          });
          this.guestOrderId=null;
        } else if(this.orderType === 'offer') {
        if(orderdCollection.automaticDeliveryLocation) {
          this.router.navigate(['/order-review']);
        } else {
          this.routeOffer();
        }
      } else if(this.orderType === 'reward' && this.pointRewardItem) {
        if(orderdCollection.automaticDeliveryLocation) {
          this.redirectToRedeemPoints(true);
        } else {
          this.routeByLoyaltyMode(LoyaltyMode.Points);
        }
      } else if(this.orderType === 'reward') {
          this.continueWithLoyaltyOrder(environment.LOYALTY_MODE, orderdCollection);
      } else {
        this.router.navigateByUrl('/order-review');
        this.orderId = null;
        this.favoriteId = null;
      }
    } else {
      this.routeStartNewOrder();
    }
  }
  private continueWithLoyaltyOrder(loyaltyMode: LoyaltyMode, orderdCollection: Store.Order) {
    if (loyaltyMode == LoyaltyMode.Points) {
      if (orderdCollection.automaticDeliveryLocation) {
        this.redirectToRedeemPoints(true);
      } else {
        this.routeByLoyaltyMode(loyaltyMode);
      }
    } else {
      this.router.navigate(['/order-review'], { queryParams: 
        UtilitiesService.generateQueryParams([Constants.RETURN_URL], [`/menu#${Constants.REWARDS_ANCHOR}`])});
    }
  }

  public redirectToRedeemPoints(isDelivery = false) {
    this.rewards.getMyConvertedRewards().then(
      success => {
        if (success?.items?.length) {
          isDelivery ? this.router.navigate(['/order-review'], { queryParams: 
            UtilitiesService.generateQueryParams([Constants.RETURN_URL], ['/rewards/my-rewards'])}) :
          this.router.navigate(['/rewards/my-rewards']);
        } else {
          isDelivery ? this.router.navigate(['/order-review'], { queryParams: 
            UtilitiesService.generateQueryParams([Constants.RETURN_URL], ['/rewards'])}) :
          this.router.navigate(['/rewards']);          
        }
      }
    ).catch(() => {
      this.router.navigate(['/order-review'], { queryParams: 
        UtilitiesService.generateQueryParams([Constants.RETURN_URL], ['/rewards']) });
    });
  }
initializePickupService() {
  this.orderType = null;
  this.orderId= null;
  this.favoriteId = null;
  this.guestOrderId = null;
  this.pointRewardItem = null;
  this.closeDeliveryAddressSubject();
  this.closePickupPathSubject();
  this.pickupPathSetSubject = new BehaviorSubject<PickupPath>(null);
  this.isPickupPathSet$ = this.pickupPathSetSubject.asObservable();
  this.deliveryAddressSetSubject = new BehaviorSubject<boolean>(false);
  this.isDeliveryAddressSet$ = this.deliveryAddressSetSubject.asObservable();
}
  routeStartNewOrder() {
    if (this.location && !this.location.isAssumedLocation && !this.location.isAutomaticDeliveryLocation) {
      this.routeOrderToLocation(this.location.unit);
    } else {
        this.routeOrderBytype();
    }
  }
  private routeOrderBytype() {
    if(this.orderType === 'offer') {
      this.routeOffer();
    } else if (this.orderType === 'reward') {
      this.routeByLoyaltyMode(environment.LOYALTY_MODE);
    } else if (this.orderType === 'order' && this.orderId) {
      this.router.navigate(['/menu'], {
        queryParams:
        UtilitiesService.generateQueryParams([Constants.ORDER_ID], [this.orderId])        
      });
    } else if (this.orderType === 'favorite' && this.favoriteId) {
      this.router.navigate(['/menu'], {
        queryParams: 
        UtilitiesService.generateQueryParams([Constants.FAVORITE_ID], [this.favoriteId])
      });
    }  else if (this.orderType === 'guestOrder') {
      this.router.navigate(['/menu'], {
        queryParams: 
        UtilitiesService.generateQueryParams([Constants.ORDER_ID, Constants.GUEST_ORDER], [this.guestOrderId, true])
      });
    } else {
    this.router.navigateByUrl('/locations');
    this.resetPickup();
    }
  }
  private routeOrderToLocation(unit) {
    if (unit) {
      if(this.orderId){
        this.router.navigate([`/locations/${unit}/menu`], {
          queryParams: 
          UtilitiesService.generateQueryParams([Constants.ORDER_ID], [this.orderId])
        });
        this.orderId = null;
      } else if(this.favoriteId) {
        this.router.navigate([`/locations/${unit}/menu/reload`], {
          queryParams: 
          UtilitiesService.generateQueryParams([Constants.FAVORITE_ID], [this.favoriteId])
        });
        this.favoriteId = null;
      } 
      else if (this.orderType === 'offer') {
        this.routeOffer();
      } else if (this.orderType === 'reward') {
        this.routeByLoyaltyMode(environment.LOYALTY_MODE);          
      } else if (this.orderType === 'customizationSummary' || this.orderType === 'customizationDetails') {
        this.orderType = null;
        return;
        // do nothing - handler is written in customization code
      } else if(this.guestOrderId) {
        this.router.navigate([`/locations/${this.location.unit}/menu/reload`], {
          queryParams: 
          UtilitiesService.generateQueryParams([Constants.ORDER_ID, Constants.GUEST_ORDER], [this.guestOrderId, true])
        });
          this.guestOrderId=null;
      }
      else {
        this.router.navigateByUrl(`/locations/${unit}/menu`);
        this.resetPickup();      
      }        

    } else {
      this.router.navigateByUrl('/locations');
      this.resetPickup();
    }
  }
  private resetPickup() {
    this.orderId = null;
    this.favoriteId = null;
  }
  public routeOffer() {
    this.orderType = null;
    const offerCategory = this.offerService.offerSelectedData.rules.filterMenu;
    if (offerCategory.length <= 1) {
      this.navigateToRecipes(offerCategory);
    } else {
      this.offerService.setOfferMenuIds(offerCategory);
      if (!this.location || this.location?.isAssumedLocation) {
        this.router.navigate(['/locations'], { queryParams: 
          UtilitiesService.generateQueryParams([Constants.RETURN_URL], ['/menu/offer'])});
      } else {
        this.router.navigateByUrl('/menu/offer');
      }
    }
    this.resetPickup();
  }

  navigateToRecipes(recipes: any) {
    const recipe = recipes[0];
    if (recipe.recipes.length <= 1) {
      this.navigateToChildrecipes(recipe.recipes, recipe.categoryId);
    } else {
      this.offerService.setOfferMenuIds(recipes);
      if (!this.location || this.location?.isAssumedLocation) {
        this.router.navigate(['/locations'], { queryParams: 
          UtilitiesService.generateQueryParams([Constants.RETURN_URL], ['/menu/offer/' + recipe.categoryId]) });
      } else {
        this.router.navigateByUrl('/menu/offer/' + recipe.categoryId);
      }
    }
  }

  navigateToChildrecipes(childRecipes: any, cid: Number) {
    const recipeId = childRecipes[0].recipeId;
    const childRecipesId = childRecipes[0].childRecipes[0].childRecipeId;
    if (!this.location || this.location?.isAssumedLocation) {
      this.router.navigate(['/locations'], { queryParams: 
        UtilitiesService.generateQueryParams([Constants.RETURN_URL], ['/customization/offer/1/' + cid + '/' + recipeId
      + '/' + childRecipesId + '/0'])
      });
    } else {
      this.router.navigate(['/customization/offer/1/' + cid + '/' + recipeId
        + '/' + childRecipesId + '/0']);
    }
  }

  private routeByLoyaltyMode(loyaltyMode: LoyaltyMode) {
    if(loyaltyMode == LoyaltyMode.Points) {
      if(this.pointRewardItem) {
        this.rewardItemService.updateCurrentRewardItem(this.pointRewardItem);      
        /* Call child recipe API to fetch Category ID Info */
        const childRecipeId = this.pointRewardItem.childRecipeIds[0];
        if(this.location?.id) {
          const apiEndpoint = ApiRoutes.LOCATIONS + this.location.id + ApiRoutes.CHILD_RECIPE + '/' + childRecipeId;
          this.http.httpGet(apiEndpoint).subscribe(
            (success) => {
              const successResponse = <ChildRecipeResponse>success.body.valueOf();
              if (successResponse !== undefined && successResponse.recipe !== undefined) {
                const childRecipeSlug = successResponse.recipe.slug;
                const childRecipeId = successResponse.recipe.id;
                if (!this.location || this.location?.isAssumedLocation) {
                  this.router.navigate(['/locations'], { queryParams: 
                    UtilitiesService.generateQueryParams([Constants.RETURN_URL], ['/menu/rewards/' + childRecipeSlug + '-' + childRecipeId + '/recipes/' +
                    this.pointRewardItem.slug + '-' + this.pointRewardItem.parentRecipeId + '/customization/1'])
                  });
                } else {
                  this.router.navigateByUrl(`/locations/${this.location.unit}/menu` + '/rewards/' + childRecipeSlug + '-' + childRecipeId + '/recipes/' +
                  this.pointRewardItem.slug + '-' + this.pointRewardItem.parentRecipeId + '/customization/1');
                }
                this.pointRewardItem = null;
              }
            }
          );
        } else {
          this.router.navigate(['/locations'], { queryParams: 
            UtilitiesService.generateQueryParams([Constants.RETURN_URL],['/menu/rewards/' +  this.pointRewardItem.childRecipeIds[0] + '/recipes/' +
          + this.pointRewardItem.parentRecipeId + '/customization/1'])});
        }
      } else {
        this.redirectToRedeemPoints();
      }
    } else if(loyaltyMode == LoyaltyMode.Visits) {
      this.orderType = null;
      if (!this.location || this.location?.isAssumedLocation) {
        this.router.navigate(['/locations'], { queryParams: 
          UtilitiesService.generateQueryParams([Constants.RETURN_URL], [`/menu#${Constants.REWARDS_ANCHOR}`])});
      } else {
        this.router.navigateByUrl(`/menu#${Constants.REWARDS_ANCHOR}`);
      }
    }  
  }
}
